
<div>
    <!-- contract edit -->
    <d-contract-lim-edit
        v-model      = "create"
        :contract-id = "-1"
        :type-id     = "typeId"
        :company-id  = "companyId"
        @saved       = "onSaved"
    />
    <!-- contract edit -->

    <c-contract-card-iterator
        :items            = "contracts"
        :selected         = selected
        :preselected      = "preselected"
        :filter           = "textfilter"
        :filter-height    = "167"
        ref               = "iterator"
    >
        <template v-slot:toolbar>
            <div class="v-flex">
                <c-header-button label="LIM" @click = "onLimCreate" :tooltip="$t('contract.create.lim')" />
                <c-header-button label="DLS" @click = "onDlsCreate" :tooltip="$t('contract.create.dls')" />
            </div>
        </template>

        <template v-slot:filter>
            <c-contract-lim-card-filter
                v-model = "filter"
                @input  = "onFilterChanged"
            />
        </template>

        <template v-slot:card="{ item }">
            <c-contract-lim-card
                :contract   = "item.item"
                :background = "`background-unset`"
                :selected   = "selected"
                :class      = "{ 'contract-inactive': !item.item.active }"
                v-on        = "item.item.active ? { selected: onSelected } : {}"
                @saved      = "onSaved"
                @renew      = "onRenew"
            />
        </template>
    </c-contract-card-iterator>
</div>
